import React, { useEffect, useState } from "react";
import { columns } from "./constants";
import { DataGrid } from "@mui/x-data-grid";
import { useDispatch, useSelector } from "react-redux";
import { Box, CircularProgress } from "@mui/material";
import { getPaginationText, hasLoading } from "../../business/helpers/util";
import { CustomPagination } from "../../components/pagination";
import "./style.css";
import { ProgressSection } from "../../components";
import { getTaskBarStatistics } from "../../business/redux/reducers/statistics/actions";
import { getTaskList } from "../../business/redux/reducers/taskReducer/actions";
import { HeaderMiddleSectionFromTaskList } from "../../components/headerSection/headerMiddleSectionFromTaskList";

export const TasksList = () => {
  const dispatch = useDispatch();
  const { loading, filters, auth, taskReducer } = useSelector((s) => s);

  const { taskList, taskListMeta } = taskReducer;
  const { taskListFilterParams } = filters;

  const [selectedLeads, setSelectedLeads] = useState({});
  const [paginationParams, setPaginationParams] = useState({
    per_page: 25,
    page: 1,
    order: {
      field: null,
      sort: "desc",
    },
  });

  useEffect(() => {
    document.title = "Account Manager Tasks";
  }, []);

  useEffect(() => {
    dispatch(
      getTaskList({ filterFormData: taskListFilterParams, paginationParams })
    );
    dispatch(getTaskBarStatistics());
  }, [auth?.__raw, JSON.stringify(paginationParams)]);

  const paginationModelChangeHandler = (e) => {
    if (hasLoading(loading)) return;
    setPaginationParams({ ...paginationParams, per_page: e.pageSize, page: 1 });
  };

  if (loading.isLoading)
    <Box
      sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
    >
      <CircularProgress />
    </Box>;

  const paginationChangeHandler = (newPage, data) => {
    setPaginationParams({
      ...paginationParams,
      per_page: data?.per_page || 25,
      page: newPage,
    });
  };

  return (
    <>
      <HeaderMiddleSectionFromTaskList />
      <ProgressSection />
      <Box sx={{ width: "100%", height: "88vh" }}>
        <DataGrid
          z
          className="custom_table"
          rows={taskList}
          columns={columns(dispatch)}
          slots={{
            pagination: CustomPagination,
          }}
          slotProps={{
            pagination: {
              data: taskListMeta,
              onChange: paginationChangeHandler,
            },
          }}
          // sortingMode="server"
          onSortModelChange={(sortModel) =>
            setPaginationParams({
              ...paginationParams,
              order: sortModel?.at(0),
            })
          }
          onPaginationModelChange={paginationModelChangeHandler}
          initialState={{ pagination: { paginationModel: { pageSize: 25 } } }}
          pageSizeOptions={[25, 50, 100]}
          rowCount={taskListMeta?.total}
          getRowClassName={(p) =>
            p.indexRelativeToCurrentPage % 2 === 0 ? "even" : "odd"
          }
          loading={loading.tableLoading}
          localeText={{
            MuiTablePagination: {
              labelRowsPerPage: `Results per page /`,
              labelDisplayedRows: getPaginationText(
                taskListMeta?.per_page || 25,
                "calls"
              ),
            },
          }}
          rowSelectionModel={selectedLeads[`page${taskListMeta?.current_page}`]}
          onRowSelectionModelChange={(e) =>
            setSelectedLeads((prev) => ({
              ...prev,
              [`page${taskListMeta?.current_page}`]: e,
            }))
          }
        />
      </Box>
    </>
  );
};
